import { render, staticRenderFns } from "./DiagnosticDetailsModal.vue?vue&type=template&id=233b58be&scoped=true&"
import script from "./DiagnosticDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosticDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticDetailsModal.vue?vue&type=style&index=0&id=233b58be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b58be",
  null
  
)

export default component.exports